export default __webpack_public_path__ + "static/media/Background-TataNeu.b4e58471.png";